import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ZendeskSvg = function ZendeskSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#03363D",
    d: "M8.942 8.263c1.436-.881 2.313-2.51 2.297-4.263H2c-.016 1.754.86 3.382 2.297 4.263a4.41 4.41 0 0 0 4.645 0M11.239 20V8.226L2 20zM12.761 20c-.016-1.754.86-3.382 2.297-4.264a4.41 4.41 0 0 1 4.645 0c1.437.882 2.313 2.51 2.297 4.264zM12.761 4v11.774L22 4z"
  }));
};
export var Zendesk = function Zendesk(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ZendeskSvg
  }));
};